import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import uuid from 'uuid/v1';

import clsx from 'clsx';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
  colors
} from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

// import axios from 'utils/axios';
import { Label, GenericMoreButton } from '../../../../components';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 700
  },
  progressContainer: {
    padding: theme.spacing(3),
    display: 'flex',
    justifyContent: 'center'
  },
  actions: {
    justifyContent: 'flex-end'
  },
  arrowForwardIcon: {
    marginLeft: theme.spacing(1)
  }
}));

const labelColors = {
  complete: colors.green[600],
  pending: colors.orange[600],
  rejected: colors.red[600]
};

const LatestOrders = props => {
  const { className, ...rest } = props;

  const classes = useStyles();
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    let mounted = true;

    const fetchOrders = () => {
      // axios.get('/api/dashboard/latest-orders').then(response => {
      //   if (mounted) {
      //     setOrders(response.data.orders);
      //   }
      // });

      setOrders([
        {
          id: uuid(),
          ref: 'DEV1042',
          items: 7,
          value: '25.00',
          currency: '$',
          customer: {
            name: 'Ekaterina Tankova',
            email: 'ekaterina@devias.io'
          },
          status: 'pending'
        },
        {
          id: uuid(),
          ref: 'DEV1041',
          items: 8,
          value: '25.00',
          currency: '$',
          customer: {
            name: 'Cao Yu',
            email: 'cao.yu@devias.io'
          },
          status: 'complete'
        },
        {
          id: uuid(),
          ref: 'DEV1040',
          items: 4,
          value: '25.00',
          currency: '$',
          customer: {
            name: 'Alexa Richardson',
            email: 'alexa.richardson@devias.io'
          },
          status: 'rejected'
        },
        {
          id: uuid(),
          ref: 'DEV1039',
          items: 1,
          value: '25.00',
          currency: '$',
          customer: {
            name: 'Anje Keizer',
            email: 'anje.keiser@devias.io'
          },
          status: 'pending'
        },
        {
          id: uuid(),
          ref: 'DEV1038',
          items: 5,
          value: '25.00',
          currency: '$',
          customer: {
            name: 'Clarke Gillebert',
            email: 'clarke.gillebert@devias.io'
          },
          status: 'complete'
        },
        {
          id: uuid(),
          ref: 'DEV1037',
          items: 2,
          value: '25.00',
          currency: '$',
          customer: {
            name: 'Merrile Burgett',
            email: 'merrile.burgett@devias.io'
          },
          status: 'complete'
        }
      ])
    };

    fetchOrders();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        action={<GenericMoreButton />}
        title="Latest Orders"
      />
      <Divider />
      <CardContent className={classes.content}>
        <PerfectScrollbar options={{ suppressScrollY: true }}>
          <div className={classes.inner}>
            {orders && (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sortDirection="desc">
                      <Tooltip
                        enterDelay={300}
                        title="Sort"
                      >
                        <TableSortLabel
                          active
                          direction="desc"
                        >
                          Date
                        </TableSortLabel>
                      </Tooltip>
                    </TableCell>
                    <TableCell>Customer</TableCell>
                    <TableCell>Items</TableCell>
                    <TableCell>Total</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell align="right">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orders.map(order => (
                    <TableRow
                      hover
                      key={order.id}
                    >
                      <TableCell>{order.ref}</TableCell>
                      <TableCell>{order.customer.name}</TableCell>
                      <TableCell>{order.items}</TableCell>
                      <TableCell className={classes.totalCell}>
                        {order.currency} {order.value}
                      </TableCell>
                      <TableCell>
                        <Label
                          color={labelColors[order.status]}
                          variant="outlined"
                        >
                          {order.status}
                        </Label>
                      </TableCell>
                      <TableCell align="right">
                        <Button
                          color="primary"
                          component={RouterLink}
                          size="small"
                          to={'management/orders/1'}
                          variant="outlined"
                        >
                          View
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button
          color="primary"
          component={RouterLink}
          size="small"
          to="management/orders"
          variant="text"
        >
          See all
          <ArrowForwardIcon className={classes.arrowForwardIcon} />
        </Button>
      </CardActions>
    </Card>
  );
};

LatestOrders.propTypes = {
  className: PropTypes.string
};

export default LatestOrders;
